if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.content = this.querySelector('.product-media-modal__content');

        this.mediaIds = [];
        this.currentIndex = 0;

        this.onKeydown = this.onKeydown.bind(this);
        this.onPrevClick = this.onPrevClick.bind(this);
        this.onNextClick = this.onNextClick.bind(this);
      }

      show(opener) {
        super.show(opener);
        this.buildMediaIndex();
        this.renderCurrentMedia();
        document.addEventListener('keydown', this.onKeydown);
      }

      hide() {
        this.teardownActiveMedia();
        if (this.content) this.content.innerHTML = '';
        document.removeEventListener('keydown', this.onKeydown);
        super.hide();
      }

      buildMediaIndex() {
        const sectionId = this.dataset.section;
        const galleryList = document.querySelector(`#Slider-Gallery-${sectionId}`);
        if (!galleryList) {
          this.mediaIds = [];
          this.currentIndex = 0;
          return;
        }

        const items = galleryList.querySelectorAll('li[data-media-id]');
        this.mediaIds = Array.from(items).map((item) => item.dataset.mediaId);

        const openerMediaId = this.openedBy?.getAttribute('data-media-id');
        const matchIndex = this.mediaIds.findIndex((id) => id.endsWith(`-${openerMediaId}`));
        this.currentIndex = matchIndex > -1 ? matchIndex : 0;
      }

      renderCurrentMedia() {
        if (!this.content || !this.mediaIds.length) return;

        const sectionId = this.dataset.section;
        const mediaId = this.mediaIds[this.currentIndex];
        const sourceSlide = document.querySelector(
          `#Slider-Gallery-${sectionId} > li[data-media-id="${mediaId}"]`
        );

        if (!sourceSlide) return;

        this.teardownActiveMedia();
        this.content.innerHTML = '';

        const modalNode = this.buildModalNode(sourceSlide);
if (!modalNode) return;

modalNode.classList.add('active');
this.content.appendChild(modalNode);
        this.updateNav();

        requestAnimationFrame(() => {
          const video = this.content.querySelector('video');
          if (!video) return;

          video.muted = true;
          video.defaultMuted = true;
          video.autoplay = true;
          video.loop = true;
          video.playsInline = true;
          video.removeAttribute('controls');

          video.setAttribute('muted', '');
          video.setAttribute('autoplay', '');
          video.setAttribute('loop', '');
          video.setAttribute('playsinline', '');

          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });
      }

      buildModalNode(sourceSlide) {
        const sourceImage = sourceSlide.querySelector('.product__media img');

        if (sourceImage) {
          const img = document.createElement('img');
          img.className = 'product-media-modal__media global-media-settings global-media-settings--no-shadow';
          img.src = sourceImage.currentSrc || sourceImage.src;
          if (sourceImage.srcset) img.srcset = sourceImage.srcset;
          img.sizes = '(min-width: 750px) 900px, 100vw';
          img.alt = sourceImage.alt || '';
          img.loading = 'eager';
          img.decoding = 'async';
          return img;
        }

        const deferredTemplate = sourceSlide.querySelector('.deferred-media template');
        if (deferredTemplate) {
          const wrap = document.createElement('div');
          wrap.className = 'product-media-modal__media product-media-modal__media--video global-media-settings global-media-settings--no-shadow';
          wrap.appendChild(deferredTemplate.content.cloneNode(true));
          return wrap;
        }

        const modelTemplate = sourceSlide.querySelector('product-model template');
        if (modelTemplate) {
          const wrap = document.createElement('div');
          wrap.className = 'product-media-modal__media product-media-modal__media--model global-media-settings global-media-settings--no-shadow';
          wrap.appendChild(modelTemplate.content.cloneNode(true));
          return wrap;
        }

        return null;
      }

      teardownActiveMedia() {
        if (!this.content) return;

        this.content.querySelectorAll('video').forEach((video) => {
          try {
            video.pause();
            video.removeAttribute('src');
            video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
            video.load();
          } catch (e) {}
        });

        this.content.querySelectorAll('iframe').forEach((iframe) => {
          const src = iframe.getAttribute('src');
          if (src) iframe.setAttribute('src', src);
        });
      }

      onPrevClick() {
        if (!this.mediaIds.length) return;
        this.currentIndex = (this.currentIndex - 1 + this.mediaIds.length) % this.mediaIds.length;
        this.renderCurrentMedia();
      }

      onNextClick() {
        if (!this.mediaIds.length) return;
        this.currentIndex = (this.currentIndex + 1) % this.mediaIds.length;
        this.renderCurrentMedia();
      }

      onKeydown(event) {
        if (!this.hasAttribute('open')) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          this.hide();
          return;
        }

      }

    }
  );
}